import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { HttpClientModule } from '@angular/common/http';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { File } from '@ionic-native/file';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { ListPage } from '../pages/list/list';

import { LoginPage } from '../pages/login/login';
import { OrdersPage } from '../pages/orders/orders';
import { OrderPage } from '../pages/order/order';
import { PrintPage } from '../pages/print/print';
import { PvPage } from '../pages/pv/pv';
import { PvsPage } from '../pages/pvs/pvs';
import { MessagesPage } from '../pages/messages/messages';
import { WareneingangPage } from '../pages/wareneingang/wareneingang';
import { ReklamationPage } from "../pages/reklamation/reklamation";

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { DataProvider } from '../providers/data/data';
import { Camera } from '@ionic-native/camera';

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    ListPage,
    LoginPage,
    OrdersPage,
    OrderPage,
    PrintPage,
    PvPage,
    PvsPage,
    MessagesPage,
    WareneingangPage,
    ReklamationPage
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp),
    HttpClientModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    ListPage,
    LoginPage,
    OrdersPage,
    OrderPage,
    PrintPage,
    PvPage,
    PvsPage,
    MessagesPage,
    WareneingangPage,
    ReklamationPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    DataProvider,
    BarcodeScanner,
    Camera,
    File
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts